// .directive('hpOverlay',

export default function OverlayDirective() {
    return {
        restrict: 'E',
        scope: {
            show: '=',
        },
        replace: true, // Replace with the template below
        transclude: true, // we want to insert custom content inside the directive
        link() {
        },
        template: "<div ng-show='show'> <div class='hp-overlay'></div> <div class='hp-overlay-container' ng-transclude> </div> </div>",
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/overlay.directive.js